import { render, staticRenderFns } from "./Chat1.container.vue?vue&type=template&id=32da3546&scoped=true&"
import script from "./Chat1.container.vue?vue&type=script&lang=js&"
export * from "./Chat1.container.vue?vue&type=script&lang=js&"
import style0 from "./Chat1.container.vue?vue&type=style&index=0&id=32da3546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32da3546",
  null
  
)

export default component.exports